import { ReactNode } from 'react'
import MarketingNavbar from '@/components/marketing/MarketingNavbar'
import MarketingFooter from '@/components/marketing/MarketingFooter'

interface MarketingLayoutProps {
	children?: ReactNode
}

const MarketingLayout = ({ children }: MarketingLayoutProps) => {
	return (
		<div className="flex min-h-screen flex-col bg-background text-foreground">
			<MarketingNavbar />
			<main className="flex-1">{children}</main>
			<MarketingFooter />
		</div>
	)
}

export default MarketingLayout
